// extracted by mini-css-extract-plugin
module.exports = {"loading":"PJQsa2s_rYn_7AyyQLkx5"};